export default "__VITE_ASSET__faf7844a__"